/**
 * The portals a new member's email can link to.
 */
export const portals = ['CustomerPortal', 'WorkPortal', 'Txf'] as const

/**
 * The portal a new member's email links to.
 */
export type Portal = (typeof portals)[number]
